import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {CookieService} from 'ngx-cookie-service';
import {AFFILIATE} from '@models/partner';

@Component({
    selector: 'app-affiliation',
    templateUrl: './affiliation.component.html',
    styleUrls: ['./affiliation.component.scss']
})
export class AffiliationComponent implements OnInit {

    params;

    constructor(
        public authenticationService: AuthenticationService,
        private router: Router,
        private cookieService: CookieService,
        private route: ActivatedRoute) {

    }

    ngOnInit(): void {

        if (this.authenticationService.isLogin) {
            this.router.navigate(['/app']);
        }

        this.route.params.subscribe(params => {
            this.params = params;
            if (params.affiliate !== undefined) {

                for (var i = 0; i < AFFILIATE.length; i++) {
                    if (AFFILIATE[i].code.toLowerCase() === params.affiliate) {
                        this.cookieService.set('affiliate-code', params.affiliate, 7, "/");
                    }
                }
                this.router.navigate(['/app/register']);
            }
        });
    }

}
